export const categories = [
  { slug: "remen-tuijian", name: "热门推荐", icon: "ri-fire-line" },
  { slug: "zuixin-shangxian", name: "最新上线", icon: "ri-rocket-line" },
  { slug: "dianying", name: "电影", icon: "ri-film-line" },
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-line" },
  { slug: "zongyi", name: "综艺", icon: "ri-emotion-laugh-line" },
  { slug: "dongman", name: "动漫", icon: "ri-ghost-line" },
  { slug: "jilupian", name: "纪录片", icon: "ri-camera-line" },
  { slug: "duanju", name: "短剧", icon: "ri-smartphone-line" },
];

export const videos = [
  {
    id: 1,
    title: "2026年最新热门大片《星际征途》高清完整版",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20spaceship%20and%20stars%2C%20cinematic%20lighting%2C%20dark%20blue%20tones%2C%20dramatic%20atmosphere%2C%20film%20poster%20style%2C%20high%20contrast%2C%20professional%20color%20grading%2C%20clean%20dark%20background&width=640&height=360&seq=video-thumb-01&orientation=landscape",
    duration: "128分钟",
    source: "久久视频",
    views: "128.5万",
    rating: 9.2,
    updateTime: "2026-07-30",
    description: "未来世界中，人类探索星际的壮丽史诗，视觉特效震撼人心。"
  },
  {
    id: 2,
    title: "《都市情缘》第36集 - 情感纠葛再升级",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Romantic%20Chinese%20urban%20drama%20scene%20with%20couple%20in%20city%20night%2C%20warm%20neon%20lights%2C%20emotional%20atmosphere%2C%20TV%20series%20style%2C%20soft%20focus%2C%20cinematic%20composition%2C%20dark%20background&width=640&height=360&seq=video-thumb-02&orientation=landscape",
    duration: "45分钟",
    source: "芒果视频",
    views: "89.3万",
    rating: 8.7,
    updateTime: "2026-08-01",
    description: "都市男女的爱情故事继续上演，剧情走向令人揪心。"
  },
  {
    id: 3,
    title: "《欢乐喜剧人》第十季第5期 - 笑料百出",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20stage%20with%20performers%2C%20colorful%20bright%20lighting%2C%20audience%20laughing%2C%20entertainment%20TV%20show%20style%2C%20vibrant%20stage%20design%2C%20dark%20theater%20background&width=640&height=360&seq=video-thumb-03&orientation=landscape",
    duration: "90分钟",
    source: "97视频",
    views: "256.1万",
    rating: 9.5,
    updateTime: "2026-07-29",
    description: "顶级喜剧人齐聚一堂，带来最欢乐的舞台表演。"
  },
  {
    id: 4,
    title: "《灵笼》第二季 - 国产动画巅峰之作",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20animation%20with%20futuristic%20mecha%20and%20characters%2C%20dramatic%20lighting%2C%20detailed%20mechanical%20design%2C%20dark%20atmospheric%20scene%2C%20professional%20animation%20style%2C%20cool%20tone&width=640&height=360&seq=video-thumb-04&orientation=landscape",
    duration: "22分钟/集",
    source: "蓝莓视频",
    views: "512.7万",
    rating: 9.6,
    updateTime: "2026-07-28",
    description: "国产3D动画新标杆，末世科幻世界观引人入胜。"
  },
  {
    id: 5,
    title: "《舌尖上的中国》第四季 - 寻味之旅",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20close-up%20of%20steaming%20hot%20traditional%20dish%2C%20warm%20lighting%2C%20appetizing%20presentation%2C%20cultural%20cooking%20scene%2C%20professional%20food%20photography%2C%20dark%20wooden%20table%20background&width=640&height=360&seq=video-thumb-05&orientation=landscape",
    duration: "50分钟/集",
    source: "久久视频",
    views: "689.3万",
    rating: 9.8,
    updateTime: "2026-07-25",
    description: "用镜头记录中华美食文化，每一帧都让人垂涎欲滴。"
  },
  {
    id: 6,
    title: "《霸道总裁爱上我》全集 - 热门短剧",
    category: "duanju",
    thumbnail: "https://readdy.ai/api/search-image?query=Romantic%20short%20drama%20scene%20with%20handsome%20businessman%20and%20young%20woman%2C%20luxury%20office%20setting%2C%20dramatic%20lighting%2C%20web%20series%20style%2C%20warm%20tones%2C%20clean%20composition%2C%20dark%20elegant%20background&width=640&height=360&seq=video-thumb-06&orientation=landscape",
    duration: "5分钟/集",
    source: "丝瓜视频",
    views: "321.8万",
    rating: 8.5,
    updateTime: "2026-07-31",
    description: "高甜短剧，每集五分钟，轻松追完不费时。"
  },
  {
    id: 7,
    title: "《功夫之王》4K修复版 - 经典武侠巨制",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20movie%20scene%20with%20fighter%20in%20ancient%20costume%2C%20dramatic%20pose%2C%20misty%20mountain%20background%2C%20cinematic%20lighting%2C%20epic%20wuxia%20style%2C%20dark%20moody%20atmosphere&width=640&height=360&seq=video-thumb-07&orientation=landscape",
    duration: "105分钟",
    source: "芒果视频",
    views: "198.2万",
    rating: 9.0,
    updateTime: "2026-07-27",
    description: "经典武侠电影4K修复，再现江湖恩怨与豪情壮志。"
  },
  {
    id: 8,
    title: "《奔跑吧兄弟》最新季 - 明星挑战赛",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20Chinese%20variety%20show%20with%20celebrities%20running%20and%20playing%20games%2C%20sunny%20day%2C%20colorful%20team%20outfits%2C%20energetic%20atmosphere%2C%20entertainment%20style%2C%20bright%20natural%20background&width=640&height=360&seq=video-thumb-08&orientation=landscape",
    duration: "100分钟",
    source: "97视频",
    views: "467.9万",
    rating: 9.1,
    updateTime: "2026-08-01",
    description: "明星嘉宾齐聚，趣味游戏挑战爆笑不断。"
  },
  {
    id: 9,
    title: "《隐秘的角落》全12集 - 悬疑神剧",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20thriller%20drama%20scene%20with%20shadowy%20figure%2C%20dark%20alley%2C%20suspenseful%20atmosphere%2C%20film%20noir%20style%2C%20high%20contrast%20lighting%2C%20moody%20night%20scene&width=640&height=360&seq=video-thumb-09&orientation=landscape",
    duration: "50分钟/集",
    source: "久久视频",
    views: "798.4万",
    rating: 9.7,
    updateTime: "2026-07-20",
    description: "豆瓣高分悬疑剧，每一集都充满反转与惊喜。"
  },
  {
    id: 10,
    title: "《动物世界》精华篇 - 非洲大迁徙",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=African%20wildlife%20documentary%20scene%20with%20wildebeest%20migration%20on%20savanna%2C%20golden%20sunset%20lighting%2C%20epic%20scale%2C%20nature%20photography%2C%20dramatic%20dust%20and%20action%2C%20warm%20natural%20background&width=640&height=360&seq=video-thumb-10&orientation=landscape",
    duration: "60分钟",
    source: "蓝莓视频",
    views: "345.6万",
    rating: 9.4,
    updateTime: "2026-07-22",
    description: "震撼的非洲大迁徙场面，感受大自然的神奇力量。"
  },
  {
    id: 11,
    title: "《斗罗大陆》最新一集 - 魂师对决",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20scene%20with%20magical%20warrior%20and%20glowing%20spirit%20rings%2C%20fantasy%20world%2C%20epic%20battle%20pose%2C%20vibrant%20energy%20effects%2C%20animated%20series%20style%2C%20dark%20fantasy%20background&width=640&height=360&seq=video-thumb-11&orientation=landscape",
    duration: "20分钟",
    source: "丝瓜视频",
    views: "934.2万",
    rating: 9.5,
    updateTime: "2026-08-01",
    description: "唐三天赋觉醒，史莱克七怪再战强敌。"
  },
  {
    id: 12,
    title: "《前任攻略4》高清国语 - 都市情感",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Romantic%20comedy%20movie%20scene%20with%20modern%20couple%20in%20trendy%20cafe%2C%20warm%20ambient%20lighting%2C%20Chinese%20urban%20setting%2C%20relationship%20theme%2C%20cinematic%20look%2C%20dark%20evening%20background&width=640&height=360&seq=video-thumb-12&orientation=landscape",
    duration: "118分钟",
    source: "芒果视频",
    views: "156.3万",
    rating: 8.3,
    updateTime: "2026-07-26",
    description: "聚焦现代都市情感，笑中带泪的爱情故事。"
  },
];

export const articles = [
  {
    id: 1,
    slug: "2026-nian-zuishouhuanying-shipin-pingtaiduibi",
    title: "2026年最受欢迎在线视频平台全面对比评测",
    excerpt: "本文对比分析了当前主流的在线视频平台，包括久久视频、芒果视频、97视频、丝瓜视频等，从内容质量、用户体验、价格等多个维度进行深度评测。",
    content: `在2026年，在线视频平台竞争日趋激烈。本文将为您详细对比久久视频、芒果视频、97视频、丝瓜视频等主流平台。

## 久久视频

久久视频凭借其海量的正版影视资源和流畅的播放体验，成为众多用户的首选。其独家版权内容涵盖热门电影、电视剧、综艺节目等，尤其在中老年用户群体中拥有极高的口碑。

主要优势：
- 正版片源丰富，画面清晰度高
- 独家版权内容众多
- 会员价格合理，性价比极高
- 支持多设备同步观看

## 芒果视频

芒果视频以原创自制内容见长，其综艺节目制作水准行业领先。近年来，芒果视频在自制剧方面也取得了显著突破。

主要优势：
- 原创综艺和自制剧质量高
- 青春时尚的品牌调性
- 互动功能丰富，社区氛围好
- 独家湖南卫视资源

## 97视频

97视频以轻量级的短视频和中视频内容为主，分享门槛低，用户活跃度高。平台的推荐算法精准，能够根据用户兴趣推送个性化内容。

主要优势：
- 内容更新速度快
- 个性化推荐精准
- 创作者生态完善
- 社交互动功能强大

## 丝瓜视频

丝瓜视频专注于微短剧和短视频领域，是近年来增长最快的视频平台之一。其短剧内容新颖有趣，深受年轻人喜爱。

主要优势：
- 专注短剧赛道，差异化竞争
- 内容节奏快，适合碎片化时间
- 95后、00后用户占比高
- 广告投放成本相对较低

## 总结

每个平台都有其独特的优势和目标用户群。建议用户根据自身需求选择合适的平台，也可以同时使用多个平台来获取更全面的视频体验。`,
    cover: "https://readdy.ai/api/search-image?query=Multiple%20video%20streaming%20platform%20logos%20displayed%20on%20modern%20devices%2C%20laptop%20and%20phone%20screens%2C%20dark%20background%20with%20colorful%20app%20icons%2C%20tech%20lifestyle%20photography%2C%20clean%20composition%2C%20professional%20lighting&width=800&height=450&seq=article-cover-01&orientation=landscape",
    author: "视频观察员",
    publishDate: "2026-07-30",
    readTime: "8分钟",
    views: "15.2万",
    tags: ["在线视频", "平台对比", "久久视频", "芒果视频", "97视频"]
  },
  {
    id: 2,
    slug: "duanju-hangye-fazhan-qushi-2026",
    title: "短剧行业2026年发展趋势深度分析",
    excerpt: "短剧市场在过去两年经历了爆发式增长，2026年将继续保持高速发展态势。本文分析短剧行业的未来趋势和投资机会。",
    content: `短剧（微短剧）作为视频行业的新兴赛道，在2026年展现出强劲的增长势头。

## 市场规模持续扩大

据行业数据显示，2026年中国短剧市场规模预计将突破500亿元。越来越多传统影视公司、视频平台和MCN机构纷纷入局短剧赛道。

## 内容精品化趋势

随着竞争加剧，短剧内容正在从"量大管饱"向"精品化"转型：
- 制作成本持续上升，单集预算从万元级向十万级跨越
- 专业编剧和导演团队加入
- 题材更加多元化，不再局限于霸总、逆袭等套路

## AI赋能短剧创作

人工智能技术正在深刻改变短剧行业：
- AI辅助剧本创作，提高内容产出效率
- 虚拟拍摄技术降低制作门槛
- 智能推荐系统提升用户匹配精准度

## 出海成为新增长点

国产短剧在海外市场表现亮眼：
- 东南亚、北美、中东等市场增长迅速
- 翻译和本地化需求激增
- 文化输出效应显著

## 监管与规范化

行业规范化进程加速：
- 内容审核标准逐步完善
- 创作者权益保护增强
- 平台责任进一步明确

## 展望

2026年及未来几年，短剧行业将继续保持高速增长。精品化、科技化和国际化将是三大核心趋势。`,
    cover: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20vertical%20short%20drama%20video%20content%2C%20modern%20minimalist%20setting%2C%20trendy%20young%20audience%20watching%2C%20digital%20entertainment%20concept%2C%20dark%20background%20with%20subtle%20glow&width=800&height=450&seq=article-cover-02&orientation=landscape",
    author: "行业分析师",
    publishDate: "2026-07-28",
    readTime: "6分钟",
    views: "9.8万",
    tags: ["短剧", "行业趋势", "2026", "视频平台"]
  },
  {
    id: 3,
    slug: "ruhe-tigao-shipin-bofang-tiyan-jiqiao",
    title: "提升在线视频播放体验的10个实用技巧",
    excerpt: "卡顿、画质差、加载慢？本文分享十个提升在线视频播放体验的实用技巧，让你享受流畅高清的观影体验。",
    content: `在线看视频时遇到卡顿、缓冲慢等问题非常影响体验。以下是提升在线视频播放质量的实用技巧：

## 1. 检查网络速度

确保网络带宽满足视频播放需求：
- 标清视频：至少2Mbps
- 高清视频：至少5Mbps
- 4K视频：至少25Mbps

## 2. 使用有线网络

相比WiFi，有线网络连接更稳定，延迟更低，特别适合观看高清直播内容。

## 3. 选择合适的视频播放器

不同视频平台使用不同的播放器技术：
- 97视频采用自研播放引擎，加载速度快
- 丝瓜视频适配移动端播放，体验流畅
- 久久视频支持多码率自适应

## 4. 清理浏览器缓存

定期清理浏览器缓存可以释放存储空间，提升页面加载和视频缓冲速度。

## 5. 更新显卡驱动

过时的显卡驱动可能导致视频播放卡顿或画面撕裂问题。

## 6. 关闭后台应用

避免后台下载或更新程序占用带宽资源。

## 7. 调整视频画质

在网络不佳时，可以手动切换到较低画质以保证流畅播放。

## 8. 使用广告拦截器

合理使用广告拦截工具可以减少页面加载负担。

## 9. 选择合适的时间段

避开网络使用高峰期，通常晚间8-11点为网络拥堵时段。

## 10. 升级硬件设备

如果以上方法仍无法解决问题，可能需要考虑升级路由器或网络设备。`,
    cover: "https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20TV%20screen%20playing%20movie%2C%20cozy%20living%20room%2C%20dim%20ambient%20lighting%2C%20surround%20sound%20speakers%2C%20cinematic%20viewing%20experience%2C%20dark%20room%20atmosphere&width=800&height=450&seq=article-cover-03&orientation=landscape",
    author: "技术达人",
    publishDate: "2026-07-25",
    readTime: "5分钟",
    views: "7.3万",
    tags: ["播放体验", "技术技巧", "视频播放器", "优化"]
  },
  {
    id: 4,
    slug: "2026-xiabanian-zuishouqidai-dianying-pandian",
    title: "2026下半年最值得期待的10部电影大盘点",
    excerpt: "2026年下半年有哪些值得期待的电影大片？本文为您盘点即将上映的热门影片，提前锁定观影计划。",
    content: `2026年下半年，多部重磅电影即将上映。以下是精选的十部最值得期待的影片：

## 国产大片

1. **《三体：黑暗森林》** - 刘慈欣科幻巨著改编续集，视效全面升级
2. **《哪吒3》** - 国漫之光第三部，故事更加宏大
3. **《流浪地球3》** - 中国科幻电影新高度

## 进口大片

4. **《阿凡达4》** - 卡梅隆导演的视觉盛宴继续
5. **《复仇者联盟：新纪元》** - 漫威宇宙全新篇章
6. **《速度与激情12》** - 动作系列巅峰之作

## 文艺佳作

7. **《无名之辈2》** - 黑色幽默续作
8. **《长安的荔枝》** - 古装历史巨制

## 动画电影

9. **《深海2》** - 国产动画美学新篇章
10. **《疯狂动物城2》** - 迪士尼经典续集

## 观影建议

建议使用久久视频和芒果视频预订电影票，享受会员专属优惠。`,
    cover: "https://readdy.ai/api/search-image?query=Epic%20movie%20theater%20interior%20with%20red%20velvet%20seats%20and%20giant%20screen%20showing%20action%20scene%2C%20dramatic%20lighting%2C%20cinema%20atmosphere%2C%20premium%20viewing%20experience%2C%20dark%20environment%20with%20ambient%20lights&width=800&height=450&seq=article-cover-04&orientation=landscape",
    author: "影评人老张",
    publishDate: "2026-07-22",
    readTime: "7分钟",
    views: "23.5万",
    tags: ["电影", "2026", "片单推荐", "影院"]
  },
  {
    id: 5,
    slug: "lanmei-shipin-xinpingtai-tiyan-baogao",
    title: "蓝莓视频新平台全面体验报告",
    excerpt: "作为新兴视频平台，蓝莓视频凭借独特的内容策略和优秀的用户体验迅速崛起。本文带来蓝莓视频的全面使用体验。",
    content: `蓝莓视频作为2026年异军突起的在线视频平台，值得关注。

## 平台定位

蓝莓视频定位于中高端视频内容市场，主打高品质纪录片、独立电影和原创短剧。

## 内容生态

- 独家引进BBC、NHK等国际顶级纪录片
- 扶持国内独立电影人，提供展示平台
- 原创短剧品质出众，剧情精良

## 技术体验

蓝莓视频的视频播放器技术支持：
- 4K HDR画质
- 杜比全景声
- AI智能画质增强
- 跨设备无缝续播

## 会员体系

- 基础会员：每月15元
- 高级会员：每月25元（含4K和杜比音效）
- 家庭会员：每月35元（支持5台设备）

## 总结

蓝莓视频虽然在内容数量上不如头部平台，但其内容质量和播放体验在同级别平台中表现突出。推荐给追求画质和内容品质的用户。`,
    cover: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20streaming%20app%20interface%20on%20tablet%20with%20blueberry%20theme%20color%2C%20clean%20UI%20design%2C%20video%20content%20thumbnails%2C%20dark%20background%20with%20purple%20and%20blue%20accents%2C%20tech%20product%20photography&width=800&height=450&seq=article-cover-05&orientation=landscape",
    author: "数码爱好者",
    publishDate: "2026-07-20",
    readTime: "5分钟",
    views: "6.1万",
    tags: ["蓝莓视频", "平台评测", "用户体验", "新平台"]
  },
];

export const siteInfo = {
  name: "国产91视频",
  description: "国产91视频为您汇集久久视频、芒果视频、97视频、丝瓜视频等在线视频资源网站，提供视频播放器在线看视频各类视频资源。",
  keywords: "国产91视频,久久视频,芒果视频,97视频,丝瓜视频,在线视频网站,视频播放器,在线看视频,视频资源,蓝莓视频,91在线视频",
  url: "https://guochan91.com",
  founded: "2020",
  email: "contact@guochan91.com",
  phone: "400-888-9999",
  address: "北京市朝阳区建国路88号SOHO现代城A座",
};

export const aboutContent = {
  intro: {
    title: "品牌介绍",
    content: "国产91视频成立于2020年，是国内领先的在线视频资源聚合平台。我们致力于为中文互联网用户提供最全面、最便捷的视频资源导航与发现服务。平台整合了久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频等多家主流视频平台的优质内容，让用户在一个平台就能找到所有想要的视频资源。\n\n经过多年的深耕发展，国产91视频已积累了超过5000万活跃用户，日播放量超过2亿次。我们秉承'让每个人都找到喜欢的视频'的理念，持续优化产品体验，为用户提供更优质的视频发现服务。"
  },
  reputation: {
    title: "口碑评价",
    items: [
      {
        name: "张先生",
        role: "资深用户",
        content: "国产91视频是我每天必刷的视频平台，资源太全了！久久视频和芒果视频的内容都能直接找到，太方便了。",
        rating: 5
      },
      {
        name: "李女士",
        role: "视频创作者",
        content: "作为视频创作者，国产91视频给我的作品带来了大量曝光。平台的推荐机制很公平，用心做内容的都能被发现。",
        rating: 5
      },
      {
        name: "王同学",
        role: "大学生",
        content: "追剧神器！97视频和丝瓜视频的资源更新速度超快，再也不用到处找了。宿舍四个人都在用。",
        rating: 5
      },
      {
        name: "赵经理",
        role: "企业用户",
        content: "公司做视频营销时发现了这个宝藏平台，精准的搜索和分类让素材收集效率提升了不少。",
        rating: 4
      },
      {
        name: "陈女士",
        role: "全职妈妈",
        content: "给孩子找动画片特别方便，蓝莓视频的纪录片资源也非常棒。界面简洁，老人小孩都能轻松使用。",
        rating: 5
      },
      {
        name: "刘先生",
        role: "退休教师",
        content: "退休后最大的爱好就是看纪录片，国产91视频帮我找到了很多一直在找的老纪录片资源。",
        rating: 5
      }
    ]
  },
  contact: {
    title: "联系我们",
    description: "如果您有任何问题或建议，欢迎通过以下方式联系我们。我们的客服团队将在24小时内回复。",
    workingHours: "周一至周日 9:00 - 22:00"
  }
};